/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CountyDictionaryDto } from './CountyDictionaryDto';
export type TerritoryDictionaryDto = {
    key?: TerritoryDictionaryDto.key;
    displayValue?: string;
    subValues?: Array<CountyDictionaryDto>;
};
export namespace TerritoryDictionaryDto {
    export enum key {
        DOLNOSLASKIE = 'DOLNOSLASKIE',
        KUJAWSKO_POMORSKIE = 'KUJAWSKO_POMORSKIE',
        LUBELSKIE = 'LUBELSKIE',
        LUBUSKIE = 'LUBUSKIE',
        LODZKIE = 'LODZKIE',
        MALOPOLSKIE = 'MALOPOLSKIE',
        MAZOWIECKIE = 'MAZOWIECKIE',
        OPOLSKIE = 'OPOLSKIE',
        PODKARPACKIE = 'PODKARPACKIE',
        PODLASKIE = 'PODLASKIE',
        POMORSKIE = 'POMORSKIE',
        SLASKIE = 'SLASKIE',
        SWIETOKRZYSKIE = 'SWIETOKRZYSKIE',
        WARMINSKO_MAZURSKIE = 'WARMINSKO_MAZURSKIE',
        WIELKOPOLSKIE = 'WIELKOPOLSKIE',
        ZACHODNIOPOMORSKIE = 'ZACHODNIOPOMORSKIE',
    }
}

